import ApplicationRole from './ApplicationRole'

export default ApplicationRole
